import React from "react";
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    icon: {
        float: 'left',
        height: '1rem'
    },
    text: {
        float: 'right',
        marginTop: '1px'
    }
});

export default function PublicIcon(props) {
    const classes = useStyles();

    return (
        <>
            <span css={`
                display: inline-block;
                font-size: 0.74rem;
                border: 1px solid #3d964f;
                color: #3d964f;
                border-radius: 25px;
                background-color: transparent;
                vertical-align: top;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                padding: 3px 10px 2px 5px;
            `}>
                <LockOpenOutlinedIcon className={classes.icon}/>
                <span className={classes.text}>
                    Public
                </span>
            </span>
        </>
    )

}